import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'ContactSearch'})
export class ContactSearchPipe implements PipeTransform
{
    transform(items:any[], search:string): any {
        console.log("Mortgage Dialer Search Called" + search);
        if (items && items.length){
            return items.filter(item =>{
                var search_number = search.match(/\d+/g);
                if(search_number)
                {   var searchno = '';
                    search_number.forEach(val=>{
                        searchno += val;
                    })

                    var cellnum = item.edit.cell_phone;
                    if(cellnum != null && cellnum !=undefined && cellnum != "null" && cellnum != "")
                    {
                        var numberPattern = /\d+/g;
                        let cellno = (cellnum).match(numberPattern);
                        cellnum = '';
                        cellno.forEach(val=>{
                            cellnum += val;
                        })
                        if(cellnum.length==10)
                            cellnum = '1'+cellnum;
                    }
                    
                    var homenum = item.edit.phone;
                    if(homenum != null && homenum !=undefined && homenum != "null" && homenum != "")
                    {
                        var numberPattern = /\d+/g;
                        let homeno = (homenum).match(numberPattern);
                        homenum = '';
                        homeno.forEach(val=>{
                            homenum += val;
                        })
                        if(homenum.length==10)
                            homenum = '1'+homenum;
                    }

                    var worknum = item.edit.work_phone;
                    if(worknum != null && worknum !=undefined && worknum != "null" && worknum != "")
                    {
                        var numberPattern = /\d+/g;
                        let workno = (worknum).match(numberPattern);
                        worknum = '';
                        workno.forEach(val=>{
                            worknum += val;
                        })
                        if(worknum.length==10)
                            worknum = '1'+worknum;
                    }

                    var zip=item.edit.zip;
                    var czip = zip.match(/\d+/g);
                    if(zip != null && zip !=undefined && zip != "null" && zip != "")
                    {
                        var zip_code = '';
                        czip.forEach(val=>{
                            zip_code += val;
                        })
                    }
                
                    if((cellnum && cellnum.indexOf(searchno) !=-1) ||
                    (homenum && homenum.indexOf(searchno) !=-1) ||
                    (worknum && worknum.indexOf(searchno) !=-1) || 
                    (zip_code && zip_code.indexOf(searchno) !=-1))
                        return true;
                    else
                        return false;
                }
                else
                {
                    if(search=='fresh' || search == 'NC' || search == 'CB' || search == 'APPT' || search == 'NI' || search == 'W#' || search == 'DK')
                    {
                        if(item.disposition===search)
                            return true;
                        else
                            return false;
                    }
                    else
                    {
                        if(sessionStorage.getItem("currcampaign") != "3")
                        {
                            var leadlevel = item.personalinfo.lead_level;
                            var assdate = item.personalinfo.assign_date;
                            var spouse_full_name = item.edit.spouse_full_name;
                        }
                        else
                        {
                            var leadlevel:any="";
                            var assdate:any="";
                            var spouse_full_name :any="";
                        }                            
                        var first_name = item.edit.first_name;
                        var last_name = item.edit.last_name;
                        var street_address_1 = item.edit.street_address_1;
                        var county = item.edit.county;
                        var state = item.edit.state;
                        var city = item.edit.city;
                        
                        if(sessionStorage.getItem("currcampaign") != "3")
                        {
                            if(leadlevel != null && leadlevel !=undefined && leadlevel != "null" && leadlevel != "")
                                leadlevel = item.personalinfo.lead_level;
                            else
                                leadlevel ="";

                            if(assdate != null && assdate !=undefined && assdate != "null" && assdate != "")
                                assdate = item.personalinfo.assign_date;
                            else
                                assdate ="";

                            if(spouse_full_name != null && spouse_full_name !=undefined && spouse_full_name != "null" && spouse_full_name != "")
                                spouse_full_name = item.edit.spouse_full_name;
                            else
                                spouse_full_name ="";

                        }

                        if(last_name != null && last_name !=undefined && last_name != "null" && last_name != "")
                            last_name = item.edit.last_name;
                        else
                            last_name ="";

                        if(first_name != null && first_name !=undefined && first_name != "null" && first_name != "")
                            first_name = item.edit.first_name;
                        else
                            first_name ="";

                        if(street_address_1 != null && street_address_1 !=undefined && street_address_1 != "null" && street_address_1 != "")
                            street_address_1 = item.edit.street_address_1;
                        else
                            street_address_1 ="";

                        if(county != null && county !=undefined && county != "null" && county != "")
                            county = item.edit.county;
                        else
                            county ="";

                        if(state != null && state !=undefined && state != "null" && state != "")
                            state = item.edit.state;
                        else
                            state ="";

                        if(city != null && city !=undefined && city != "null" && city != "")
                            city = item.edit.city;
                        else
                            city ="";

                        
                        var fullname = first_name+" "+last_name;                           
                        if (search && first_name.toLowerCase().indexOf(search.toLowerCase()) === -1 &&
                        last_name.toLowerCase().indexOf(search.toLowerCase()) ===-1  &&
                        fullname.toLowerCase().indexOf(search.toLowerCase()) ===-1  && 
                        street_address_1.toLowerCase().indexOf(search.toLowerCase()) ===-1  &&
                        county.toLowerCase().indexOf(search.toLowerCase()) ===-1  &&
                        state.toLowerCase().indexOf(search.toLowerCase()) ===-1  &&
                        city.toLowerCase().indexOf(search.toLowerCase()) ===-1  && 
                        leadlevel.toLowerCase().indexOf(search.toLowerCase()) === -1 &&
                        assdate.toLowerCase().indexOf(search.toLowerCase()) === -1 ){
                            if(spouse_full_name && spouse_full_name.toLowerCase().indexOf(search.toLowerCase()) === -1)
                                return false;
                            else
                                return false;
                        }
                        else
                            return true;
                    }
                }
        })
        }
        else
        {
            return items;
        }
    }
}